<!-- Иконка открытия навигационного меню. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7H20M4 12H20M4 17H20"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "MenuIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
